import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Beim App-Start: prüfen ob noch ein gültiger Token im localStorage liegt
  useEffect(() => {
    const storedToken = localStorage.getItem('caisar_token');
    const storedUser = localStorage.getItem('caisar_user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  function login(tokenValue, userData) {
    localStorage.setItem('caisar_token', tokenValue);
    localStorage.setItem('caisar_user', JSON.stringify(userData));
    setToken(tokenValue);
    setUser(userData);
  }

  function logout() {
    localStorage.removeItem('caisar_token');
    localStorage.removeItem('caisar_user');
    setToken(null);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
